import { ExpandableContainerModule } from "./../expandable-container/expandable-container.module";
import { ExpandableModule } from "./../expandable/expandable.module";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "./../button/button.module";
import { NgModule } from "@angular/core";
import { BlockComponent } from "./block.component";
import { IconModule } from "./../icon/icon.module";

@NgModule({
	declarations: [BlockComponent],
	imports: [CommonModule, IconModule, ButtonModule, ExpandableModule, ExpandableContainerModule],
	exports: [BlockComponent]
})
export class BlockModule { }
